// organizationSaga.js
import { call, put, takeLatest, select } from "redux-saga/effects"
import {
  FETCH_ORGANIZATIONS_REQUEST,
  CREATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILURE,
} from "./actionTypes"
import {
  fetchOrganizationsSuccess,
  fetchOrganizationsFailure,
  createOrganizationSuccess,
  createOrganizationFailure,
  updateOrganizationSuccess,
  updateOrganizationFailure,
  clearOrganizationState,
} from "./actions"

import axios from "axios"
import config from "../../config/config"

const getToken = state => state.Login.userData.token
const getUserId = state => state.Login.userData.id

const fetchOrganizationsApi = async (userId, token) => {
  const response = await axios.get(
    `${config.backendUrl}/user/getLoginUser?userId=${userId}`,
    { headers: { Authorization: `Bearer ${token}` } },
  )
  return response.data.userInfo.assignedOrganizations
}

const createOrUpdateOrganizationApi = async (organization, token) => {
  // Get the token from the Redux state

  const response = await axios.post(
    `${config.backendUrl}/organization/createOrUpdateOrganization`,
    {
      // Include organizationId in the request body
      organization, // Include organization data
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )

  console.log("update ", response.data)
  return response.data
}

const createOrganizationApi = async organizationData => {
  // Simulate an API request to create a new organization
  return await fetch("/api/organizations", {
    method: "POST",
    body: JSON.stringify(organizationData),
    headers: { "Content-Type": "application/json" },
  }).then(response => response.json())
}

// Fetch Organizations Saga
function* fetchOrganizations() {
  try {
    const token = yield select(getToken)
    const userId = yield select(getUserId)
    const organizations = yield call(fetchOrganizationsApi, userId, token)
    yield put(fetchOrganizationsSuccess(organizations))
  } catch (error) {
    yield put(fetchOrganizationsFailure(error.message))
  }
}

// Create Organization Saga
function* createOrganization(action) {
  const { organizationId, organization } = action.payload
  const token = yield select(getToken)
  try {
    const newOrganization = yield call(
      createOrganizationApi,
      organizationId,
      organization,
      token,
    )
    yield put(createOrganizationSuccess(newOrganization))
  } catch (error) {
    yield put(createOrganizationFailure(error.message))
  }
}

function* updateOrganization({ payload }) {
  const token = yield select(getToken)
  try {
    try {
      if (Object.keys(payload.organizationData).length == 1) {
        yield put(updateOrganizationFailure("Nothing to Update"))
        return
      }
      const updatedOrganization = yield call(
        createOrUpdateOrganizationApi,
        payload.organizationData,
        token,
      )
      yield put(updateOrganizationSuccess(updatedOrganization)) // Dispatch success action
    } catch (error) {
      if (error.status == 500) {
        yield put(
          updateOrganizationFailure(
            "Failed to update Organization - Network Error",
          ),
        ) // Dispatch failure action
      } else {
        yield put(updateOrganizationFailure(error.message)) // Dispatch failure action
      }
    }

    // Dispatch success action with the updated organization
    // yield put({
    //   type: UPDATE_ORGANIZATION_SUCCESS,
    //   payload: updatedOrganization,
    // })
  } catch (error) {
    // Dispatch failure action if there's an error
    yield put({ type: UPDATE_ORGANIZATION_FAILURE, payload: error.message })
  }
}

// Watcher Saga
export default function* organizationSaga() {
  yield takeLatest(FETCH_ORGANIZATIONS_REQUEST, fetchOrganizations)
  yield takeLatest(CREATE_ORGANIZATION_REQUEST, createOrganization)
  yield takeLatest(UPDATE_ORGANIZATION_REQUEST, updateOrganization)
}
